import * as yup from "yup";

export const WSIBClassRateSetupValidationSchema = yup.object().shape({
  provinceId: yup.string().required("Province is required"),
  classId: yup.string().required("Class is required"),
  rate: yup.string().required("Rate is required"),
  effectiveDate: yup.string().required("Effective Date is required"),
});
